module.exports = __webpack_public_path__ + "img/hero-3.9facae3.jpg";